
namespace RedBullMOBILE360.AutomaticReports {

    @Serenity.Decorators.registerClass()
    export class ReportPartGrid extends Serenity.EntityGrid<ReportPartRow, any> {
        protected getColumnsKey() { return ReportPartColumns.columnsKey; }
        protected getDialogType() { return ReportPartDialog; }
        protected getIdProperty() { return ReportPartRow.idProperty; }
        protected getInsertPermission() { return ReportPartRow.insertPermission; }
        protected getLocalTextPrefix() { return ReportPartRow.localTextPrefix; }
        protected getService() { return ReportPartService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}